import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { MatchingAutoComponent } from './auto/auto.component';
import { MatchingProjectListComponent } from './project/list/list.component';
import { MatchingProjectDetailComponent } from './project/detail/detail.component';
import { MatchingWorkerListComponent } from './worker/list/list.component';
import { MatchingWorkerDetailComponent } from './worker/detail/detail.component';

const routes: Routes = [
  { path: 'auto', component: MatchingAutoComponent },
  { path: 'projects', component: MatchingProjectListComponent },
  { path: 'projects/:id', component: MatchingProjectDetailComponent },
  { path: 'workers', component: MatchingWorkerListComponent },
  { path: 'workers/:id', component: MatchingWorkerDetailComponent }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class MatchingRoutingModule {}
